import useAuth from '@app/auth/use-auth';
import {
  PurchasedGoodModelledAsEnum,
  SoldGoodModelledAsEnum,
} from '@shared/api/types';
import { Icons } from '@shared/components/content/icons';

export const purchasedFoodModellingOptions = [
  {
    label: 'Basic food',
    value: PurchasedGoodModelledAsEnum.basic_food,
    icon: <Icons.carrot className="size-4" />,
    description: 'Match to a single item in our database',
  },
  {
    label: 'Recipe',
    value: PurchasedGoodModelledAsEnum.modelled_food,
    icon: <Icons.chefHat className="size-4" />,
    description: 'Input or generate a recipe',
  },
  {
    label: 'External product assessment',
    value: PurchasedGoodModelledAsEnum.external_emission_factor,
    icon: <Icons.arrowUpCircle className="size-4" />,
    description: 'Enter an emission factor from elsewhere',
  },
];

export const useSoldFoodModellingOptions = () => {
  const { user } = useAuth();
  const { features } = user!;
  const hasPurchasedGoodsAccess = features.scope3;

  return [
    {
      label: 'Basic food',
      value: SoldGoodModelledAsEnum.basic_food,
      icon: <Icons.carrot className="size-4" />,
      description: 'Match to a single item in our database',
    },
    {
      label: 'Recipe',
      value: SoldGoodModelledAsEnum.modelled_food,
      icon: <Icons.chefHat className="size-4" />,
      description: 'Input or generate a recipe',
    },
    {
      label: 'External product assessment',
      value: SoldGoodModelledAsEnum.external_emission_factor,
      icon: <Icons.arrowUpCircle className="size-4" />,
      description: 'Enter an emission factor from elsewhere',
    },
    ...(features.pcf || hasPurchasedGoodsAccess
      ? [
          {
            label: 'Another item in my account',
            value: SoldGoodModelledAsEnum.product,
            icon: <Icons.salad className="size-4" />,
            description: 'Link to a product or purchased good in your account',
          },
        ]
      : []),
    ...(hasPurchasedGoodsAccess
      ? [
          {
            label: 'Another item in my account',
            value: SoldGoodModelledAsEnum.purchased_good,
            icon: <Icons.salad className="size-4" />,
            description: 'Link to a product or purchased good in your account',
            hidden: true,
          },
        ]
      : []),
  ];
};
